export const FIELD_TYPES = {
    Input: 'input',
    Multiline: 'multiline',
    MultipleChoice: 'multi-choice',
    SingleChoice: 'single-choice',
};

export const EMAIL_KEY = 'email';

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
};

export type HttpStatusCode = typeof HTTP_STATUS[keyof typeof HTTP_STATUS];

type SCHEMA_TYPE = "string" | "object" | "array";
export type FIELD_TYPE = (typeof FIELD_TYPES)[keyof typeof FIELD_TYPES];

export interface SchemaProperty {
    title: string;
    type: SCHEMA_TYPE;
    format?: string;
};

export interface Schema {
    title?: string;
    properties: {
        [key: string]: SchemaProperty;
    };
};

export interface UISchemaProperty {
    type: FIELD_TYPE;
    order: number;
    fieldsPerRow?: number;
    label?: boolean;
    placeholder?: boolean;
    isRequired?: boolean;
    isDraggable?: boolean;
    isRemovable?: boolean;
    pattern?: string;
    options?: string[];
};

export interface FormSettings {
    language?: string;
    logoUrl?: string;
    textColor?: string;
    buttonColor?: string;
    buttonTextColor?: string;
    privacyPolicyLink?: string;
}

export interface uiSchema {
    properties: {
        [key: string]: UISchemaProperty;
    };
};

export interface formTemplateType {
    id: string;
    name: string;
    description?: string;
    accountId: string;
    medias?: string[];
    schema: Schema;
    styling: uiSchema;
    settings?: FormSettings;
    createdAt: string;
    createdBy?: string;
    updatedAt?: string;
    updatedBy?: string;
    optional?: boolean;
};

export interface SubmitFormDataProps {
    accountId: string;
    formId: string;
    payload: object;
};

export interface FormTemplateProps {
	accountId: string;
	formId: string;
};

export interface RegisterFormProps {
    playerConfigs?: any;
    isMobile: boolean;
    playerId?: string;
}